// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__SAuTV","right":"Footer_right__Gtygx","buttons":"Footer_buttons__Mwpix"};